import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { PermissionChecker } from "../services/permission-checker.service";

export const roleGuard: CanActivateFn = (route) => {
  const permissionChecker = inject(PermissionChecker);
  const router = inject(Router);
  const allowed = route.data["role"] as string | string[];
  const businessId =
    route.paramMap.get("businessId") ||
    route.parent?.paramMap.get("businessId") ||
    route.parent?.parent?.paramMap.get("businessId") ||
    undefined;

  return permissionChecker.hasRole(allowed, businessId).pipe(
    map((ok) => {
      if (ok) return true;
      if (businessId) {
        return router.createUrlTree(["/", businessId, "dashboard"]);
      }
      return router.createUrlTree(["/select-business"]);
    }),
  );
};
